import { Injectable } from "@angular/core";
import { uuid } from "src/app/support/uuid";

import { sntLog } from "src/app/common/logger";

const logger = sntLog("FileSystemStorageService");
@Injectable()
export class FileSystemStorageService {
  async create({ content }: { content: Blob }): Promise<string> {
    const name = uuid();
    const opfsRoot = await navigator.storage.getDirectory();

    const fileHandle = await opfsRoot.getFileHandle(name, {
      create: true
    });

    const writable = await fileHandle.createWritable();

    await writable.write(content);
    await writable.close();

    return name;
  }

  async load({ name }: { name: string }): Promise<File> {
    const opfsRoot = await navigator.storage.getDirectory();

    const fileHandle = await opfsRoot.getFileHandle(name, {
      create: false
    });

    return await fileHandle.getFile();
  }

  async remove(name: string): Promise<void> {
    const opfsRoot = await navigator.storage.getDirectory();
    try {
      await opfsRoot.removeEntry(name);
    } catch (error) {
      logger.warn(error);
    }
  }
}
